import axios from 'axios';
import { readAuthSession } from '../auth/authStorage';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://api.integranube.cl',
  timeout: 12000,
});

api.interceptors.request.use((config) => {
  const session = readAuthSession();

  // Respeta un Authorization explícito (por ejemplo, durante /auth/me
  // inmediatamente después de /auth/login). No debe ser sobrescrito por
  // una sesión anterior que todavía pudiera existir en storage.
  if (session.token && !config.headers?.Authorization) {
    config.headers.Authorization = `Bearer ${session.token}`;
  }

  // Algunas llamadas de autenticación necesitan ejecutarse sin contexto de tenant.
  // `skipTenant` se usa únicamente para ese propósito.
  if (!config.skipTenant && session.tenantid) {
    config.headers.TenantId = session.tenantid;
  }

  return config;
});

export default api;
